'use strict';

(function (angular) {
    angular.module('zp').constant('homeContent', {
        sliderConfig: [{
            breakpoint: 1100,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
            }
        }, {
            breakpoint: 850,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        }],
        sections: [{
            name: 'prostori',
            title: 'Naša preporuka Prostora',
            subtitle: 'posebno preporučeni samo za Vas',
            button: 'Pregledajte sve Prostore',
            limit: 6,
            type: 'slider',
            recommended: []
        }, {
            name: 'muzika',
            title: 'Naša preporuka Bendova',
            subtitle: 'posebno preporučeni samo za Vas',
            button: 'Pregledajte sve Bendove',
            limit: 6,
            type: 'slider',
            recommended: []
        }, {
            name: 'vencanice',
            title: 'Naša preporuka Venčanica',
            subtitle: 'posebno preporučeni samo za Vas',
            button: 'Pregledajte sve Venčanice',
            limit: 9,
            type: 'grid',
            recommended: []
        }, {
            name: 'torte',
            title: 'Naša preporuka Poslastičarnica',
            subtitle: 'posebno preporučeni samo za Vas',
            button: 'Pregledajte sve Poslastičarnice',
            limit: 9,
            type: 'grid',
            recommended: []
        }, {
            name: 'zlatare',
            title: 'Naša preporuka Zlatara',
            subtitle: 'posebno preporučeni samo za Vas',
            button: 'Pregledajte sve Zlatare',
            limit: 8,
            type: 'slider',
            recommended: []
        }]
    });
})(window.angular);